import React, { useContext, useState, createContext, useEffect } from 'react';
import { $auth, getUser, UserData } from "./store/auth"

import { getPlays } from './store/plays';
import { getFolders } from './store/playFolders';
import { $isOnline, pingVersionCheck } from './store/app';

export type AuthContextType = UserData & { loading: boolean }

const defaultAuthContext: AuthContextType = {
  isPro: false,
  isAdmin: false,
  isBasic: false,
  loading: true,
}

const AuthContext = createContext<AuthContextType>(defaultAuthContext)

export const useAuthContext = () => useContext<AuthContextType>(AuthContext)

export const AuthProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [authContext, setAuthContextCtx] = useState<AuthContextType>(defaultAuthContext)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  $auth.subscribe((value, oldValue, key) => {
    if (!value.user) {
      return
    }
    if (!key) {
        return;
    }
    setAuthContextCtx({
      loading: false,
      ...value.user,
    })
  })

  useEffect(() => {
    const initAuth = async () => {
      setLoading(true)
      try {
        const isOnlineNow = await pingVersionCheck()
        $isOnline.set(isOnlineNow)
        const user = await getUser()
        if (user) {
          setAuthContextCtx({
            ...user,
            loading: false,
          })
          setLoading(false)
          void getPlays()
          void getFolders()
        }
      } catch (e) {
        setAuthContextCtx({
          ...defaultAuthContext,
          loading: false,
        })
        if (e === 'UNAUTHORIZED') {
          $auth.setKey('isInit', false)
        }
      }
    }
    void initAuth()
  }, []);

  return (
    <AuthContext.Provider value={authContext}>
      {children}
    </AuthContext.Provider>
  )
}
